import React, { Component } from 'react';

import { Polyline } from 'google-maps-react';

import { FilterPoles, CompareBounds } from '../../../helpers/poleHelpers';
import { FilterSpans, GetDividedSpans, GetPhasesLocations } from '../../../helpers/spanHelpers';


class Phase extends Component {

    componentDidMount() {
        this.loadPhases();
    }

    shouldComponentUpdate(nextProps) {
        if (this.props.ohlsList.length !== nextProps.ohlsList.length
            || this.props.zoomLevel !== nextProps.zoomLevel
            || CompareBounds(this.props.zoomLevel, this.props.bounds, nextProps.bounds)) {
            return true
        }
        else {
            return false;
        }
    }

    componentDidUpdate(){
        this.loadPhases();
    }

    loadPhases = () => {

        let resultList = [];

        if (this.props.zoomLevel === 3) {

            this.props.ohlsList.forEach(ohl => {

                let polesInRangeList = ohl.stubovi.filter(stub => stub.portal !== true);
                let spansInRangeList = ohl.rasponi;

                if (this.props.bounds && this.props.zoomLevel > 1) {
                    polesInRangeList = FilterPoles(ohl.stubovi, this.props.bounds);
                    spansInRangeList = FilterSpans(ohl.rasponi, this.props.bounds);
                }
                // if(polesInRangeList.length > 0){
                //     debugger;
                // }

                let phases = GetPhasesLocations(GetDividedSpans(this.props.ohlsList, polesInRangeList, spansInRangeList, ohl.position, [], ohl.name), ohl.phaseCross, ohl.phases)
                    .map((phase, phaseIndex) =>
                        <Polyline
                            key={ohl.name + phase.phase + String(phaseIndex)}
                            path={phase.path}
                            clicable
                            name={phase.phase}
                            strokeOpacity={0.8}
                            strokeColor={phase.phase === 0 ? '#ff0000' : phase.phase === 4 ? '#00bfff' : '#ff00ff'}
                            onClick={this.props.onPhaseClick}
                            strokeWeight={3}
                            ohlName={ohl.name}
                            spanName={phase.spanName}
                            position={phase.position}
                        />
                    )
                resultList = resultList.concat(phases);
            });
        }

        this.props.sendChildElementDataToState(this.props.stateElementName, resultList);
    }

    render() {
        return null;
    }
}

export default Phase;